/**
 * Created by olga on 26.06.2025
 */

const HomefixIdComponentView = function (component, unitView) {
    this.unitView = unitView;
    this.component = component;

    if (!cleverapps.config.adminMode) {
        this.restoreState();

        Homefix.currentHomefix.on("newTask", this.restoreState.bind(this, true), this.unitView);
        cleverapps.meta.on("changeStars", this.restoreState.bind(this, true), this.unitView);

        component.onSpendStarAnimation = this.spendStarAnimation.bind(this); 
    }
};

HomefixIdComponentView.prototype.restoreState = function (animated) {
    if (this.component.furniture.isCurrent() && !this.component.furniture.isComplete()) {
        this.createTaskIcon(animated);
    } else {
        this.removeTaskIcon(animated);
    }
};

HomefixIdComponentView.prototype.spendStarAnimation = function (callback) {
    LocationStarAnimation.createSpendAnimation({
        callback,
        amount: this.component.furniture.getInfo().cost,
        target: this.taskIcon,
        source: cleverapps.aims.getTarget("metaStar")
    });
};

HomefixIdComponentView.prototype.createTaskIcon = function (animated) {
    if (this.taskIcon) {
        this.taskIcon.updateReady(animated);
        return;
    }
        
    this.taskIcon = new TaskIcon(this.component, this.component.unit.handleClick.bind(this.component.unit));
    this.unitView.createAdditionalView("homeTask", this.taskIcon);

    if (animated && !this.component.unit.additionalViewsHidden) {
        const additionalView = this.unitView.getAdditionalView("homeTask");
        additionalView.animateAppear();
    }
};

HomefixIdComponentView.prototype.removeTaskIcon = function (animated) {
    this.unitView.removeAdditionalView("homeTask", !animated);
};
